module.exports={Announcements:"公告",MarkAllAsRead:"全部標記為已讀",NoLinkNotification:"沒有此通知的連結",Notification:"通知",ViewAll:"檢視全部"};